<template>
  <div class="conatiner">
  <Row><Col span="24" style="height:700px;">
   <div class="success">
     <br>
     <h1 style="color: orange">注册成功</h1>
     <br/>

     <h3>请选择账户为个人账户或企业账户</h3>
      <Form>
        <FormItem >
          <Col span="12" offset="6">
            <RadioGroup v-model="userType">
              <Radio :label="1">个人账户</Radio>
              <Radio :label="2">企业账户</Radio>
            </RadioGroup>
          </Col>
        </FormItem>
        <FormItem :visible.sync="dialogVisible">
          <Col span="10" offset="7">
            <Button type="warning" style="width:180px;"  @click="goSetUserType">确定</Button>
          </Col>

        </FormItem>
      </Form>
   </div>
   </Col></Row>
   </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
    export default {
        name: "index",
         data() {
          return {
             dialogVisible : false,
             userType: 1
          };
         },
        computed: {
          ...mapGetters(["sessionInfoGetter"])
        },
        mounted() {
           if(this.sessionInfoGetter.userModel!=null){
              let userModel = JSON.parse(this.sessionInfoGetter.userModel);
              if(userModel.type==null){
                this.userType = 1;
                this.dialogVisible = true;
              }else{
                 this.userType=userModel.type;
              }
            }else{
              //未登录，自动跳转到登录
              this.$router.push({ path: "/load" });
            }
        },
        methods: {
          goSetUserType: function() {
            protocol.param_setUserType.data.type = this.userType;
            http.get(protocol.param_setUserType,protocol.param_setUserType.data).then(response => {
              if (response.data.code == 0) {
                 window.location.href = "http://223.0.12.32:8081/#/home";
                 //状态改变之后从新获取下用户信息。
                  let userModel = JSON.parse(this.sessionInfoGetter.userModel);
                  userModel.type= this.userType;
              } else {
                 this.$message({ type: "warning", message: response.data.msg });
              }
          });
          },
          //向localStorage里存入从页面获取的用户名和密码；
          setlocalStorage(info) {
            localStorage.jmjInfo = JSON.stringify(info)
          }
        }
    }
</script>

<style scoped>
  .conatiner{
    opacity: 0.9;
    background-size: cover;
    background-image: url("../../../static/16.jpg");
    /*position: fixed;
    height: 100%;
    width: 100%;*/
    margin:0 auto;
    height: 700px;
    width: 1200px;
    border-bottom:1px solid black;

  }
  .success{
    /*position: absolute;
    top: 240px;
    left: 650px;
    background: whitesmoke;
    width: 600px;
    height: 300px;
    border-radius: 5px;*/
    top: 200px;
    width: 605px;
    height: 284px;
    margin:150px auto;
    background: whitesmoke;
  }


</style>



// WEBPACK FOOTER //
// src/views/success/index.vue